import React, { useEffect, useState } from 'react';
import NextLink from 'next/link';
import {
	Box, Heading, Center, Text, Table, Thead, Tbody, Tr, Th, Td, Icon, Tab, Tabs, TabList, TabPanels, TabPanel, Link as ChakraLink, Tooltip,
} from '@chakra-ui/react';
import { useTable, useSortBy } from 'react-table';
import { ResponsiveLine } from '@nivo/line';
import { FontAwesomeIcon as Fa } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import pangu from 'pangu';
import data2017 from './data/score2017.json';
import data2018 from './data/score2018.json';
import data2019 from './data/score2019.json';
import data2020 from './data/score2020.json';
import Page from '../../components/Page';

export default function Od34() {
	const columns = React.useMemo(() => [
		{
			Header: '#',
			accessor: 'name',
			disableSortBy: true,
		},
		{
			Header: '共同基礎分數',
			columns: [
				{
					Header: '2017',
					accessor: 'score2017.score1',
					isNumeric: true,
					Cell: ({ row }) => (Math.round(row.original?.score2017?.score1)) || 0,
				},
				{
					Header: '2018',
					accessor: 'score2018.score1',
					isNumeric: true,
					Cell: ({ row }) => (Math.round(row.original?.score2018?.score1)) || 0,
				},
				{
					Header: '2019',
					accessor: 'score2019.score1',
					isNumeric: true,
					Cell: ({ row }) => (Math.round(row.original?.score2019?.score1)) || 0,
				},
				{
					id: 'score2020_score1',
					Header: '2020',
					accessor: 'score2020.score1',
					isNumeric: true,
					Cell: ({ row }) => (Math.round(row.original?.score2020?.score1)) || 0,
				},
				{
					Header: '趨勢',
					id: 'trend1',
					disableSortBy: true,
					Cell: ({ row }) => (
						<Center>
							<Box width="100px" height="20px" border="1px solid #ccc">
								<ResponsiveLine
									data={[{
										id: 'id',
										data: Array(4).fill(0).map((_, i) => i + 2017).map((x) => ({
											x,
											y: row.original?.[`score${x}`]?.score1 ?? 0,
										})),
									}]}
									margin={{
										top: 5,
										right: 5,
										bottom: 5,
										left: 5,
									}}
									yScale={{ type: 'linear', min: 0, max: 100 }}
									pointSize={4}
									enableGridX={false}
									enableGridY={false}
									axisLeft={null}
									axisBottom={null}
									colors={{ scheme: 'dark2' }}
								/>
							</Box>
						</Center>
					),
				},
			],
		},
		{
			Header: '詮釋規範分數',
			columns: [
				{
					Header: '2017',
					accessor: 'score2017.score2',
					isNumeric: true,
					Cell: ({ row }) => (Math.round(row.original?.score2017?.score2)) || 0,
				},
				{
					Header: '2018',
					accessor: 'score2018.score2',
					isNumeric: true,
					Cell: ({ row }) => (Math.round(row.original?.score2018?.score2)) || 0,
				},
				{
					Header: '2019',
					accessor: 'score2019.score2',
					isNumeric: true,
					Cell: ({ row }) => (Math.round(row.original?.score2019?.score2)) || 0,
				},
				{
					Header: '2020',
					accessor: 'score2020.score2',
					isNumeric: true,
					Cell: ({ row }) => (Math.round(row.original?.score2020?.score2)) || 0,
				},
				{
					Header: '趨勢',
					id: 'trend2',
					disableSortBy: true,
					Cell: ({ row }) => (
						<Center>
							<Box width="100px" height="20px" border="1px solid #ccc">
								<ResponsiveLine
									data={[{
										id: 'id',
										data: Array(4).fill(0).map((_, i) => i + 2017).map((x) => ({
											x,
											y: row.original?.[`score${x}`]?.score2 ?? 0,
										})),
									}]}
									margin={{
										top: 5,
										right: 5,
										bottom: 5,
										left: 5,
									}}
									yScale={{ type: 'linear', min: 0, max: 100 }}
									pointSize={4}
									enableGridX={false}
									enableGridY={false}
									axisLeft={null}
									axisBottom={null}
									colors={{ scheme: 'dark2' }}
								/>
							</Box>
						</Center>
					),
				},
			],
		},
		{
			Header: '國發會金銀銅標章',
			columns: [
				{
					Header: '2017',
					accessor: 'score2017.ndcRating',
					isNumeric: true,
					Cell: ({ row }) => (Math.round(row.original?.score2017?.ndcRating)) || 0,
				},
				{
					Header: '2018',
					accessor: 'score2018.ndcRating',
					isNumeric: true,
					Cell: ({ row }) => (Math.round(row.original?.score2018?.ndcRating)) || 0,
				},
				{
					Header: '2019',
					accessor: 'score2019.ndcRating',
					isNumeric: true,
					Cell: ({ row }) => (Math.round(row.original?.score2019?.ndcRating)) || 0,
				},
				{
					Header: '2020',
					accessor: 'score2020.ndcRating',
					isNumeric: true,
					Cell: ({ row }) => (Math.round(row.original?.score2020?.ndcRating)) || 0,
				},
				{
					Header: '趨勢',
					id: 'trend3',
					disableSortBy: true,
					Cell: ({ row }) => (
						<Center>
							<Box width="100px" height="20px" border="1px solid #ccc">
								<ResponsiveLine
									data={[{
										id: 'id',
										data: Array(4).fill(0).map((_, i) => i + 2017).map((x) => ({
											x,
											y: row.original?.[`score${x}`]?.ndcRating ?? 0,
										})),
									}]}
									margin={{
										top: 5,
										right: 5,
										bottom: 5,
										left: 5,
									}}
									yScale={{ type: 'linear', min: 0, max: 100 }}
									pointSize={4}
									enableGridX={false}
									enableGridY={false}
									axisLeft={null}
									axisBottom={null}
									colors={{ scheme: 'dark2' }}
								/>
							</Box>
						</Center>
					),
				},
			],
		},
	], []);

	const [data, setData] = useState([]);

	useEffect(() => {
		let scores = [];
		scores = data2017.reduce((acc, d) => {
			let found = true;
			let _data = acc.find((x) => x.name === d.City);
			if (!_data) {
				found = false;
				_data = {
					name: d.City,
					score2017: {
						score1: 0,
						score2: 0,
						ndcRating: 0,
						ndc: {
							g: 0, s: 0, b: 0, n: 0,
						},
					},
					score2018: {
						score1: 0,
						score2: 0,
						ndcRating: 0,
						ndc: {
							g: 0, s: 0, b: 0, n: 0,
						},
					},
					score2019: {
						score1: 0,
						score2: 0,
						ndcRating: 0,
						ndc: {
							g: 0, s: 0, b: 0, n: 0,
						},
					},
					score2020: {
						score1: 0,
						score2: 0,
						ndcRating: 0,
						ndc: {
							g: 0, s: 0, b: 0, n: 0,
						},
					},
				};
			}
			const _score = _data.score2017;
			_score.score1 += Number(d.Part1);
			_score.score2 += Number(d.Part2);
			switch (d.NdcRating) {
			case '金':
				_score.ndcRating += 1;
				_score.ndc.g += 1;
				break;
			case '銀':
				_score.ndcRating += 0.6;
				_score.ndc.s += 1;
				break;
			case '銅':
				_score.ndcRating += 0.3;
				_score.ndc.b += 1;
				break;
			default:
				if (Number(d.Part1) !== 0 && Number(d.Part2) !== 0) {
					_score.ndc.n += 1;
				}
			}
			if (!found) {
				acc.push(_data);
			}
			return acc;
		}, scores);
		scores = data2018.reduce((acc, d) => {
			let found = true;
			let _data = acc.find((x) => x.name === d.City);
			if (!_data) {
				found = false;
				_data = {
					name: d.City,
					score2017: {
						score1: 0,
						score2: 0,
						ndcRating: 0,
						ndc: {
							g: 0, s: 0, b: 0, n: 0,
						},
					},
					score2018: {
						score1: 0,
						score2: 0,
						ndcRating: 0,
						ndc: {
							g: 0, s: 0, b: 0, n: 0,
						},
					},
					score2019: {
						score1: 0,
						score2: 0,
						ndcRating: 0,
						ndc: {
							g: 0, s: 0, b: 0, n: 0,
						},
					},
					score2020: {
						score1: 0,
						score2: 0,
						ndcRating: 0,
						ndc: {
							g: 0, s: 0, b: 0, n: 0,
						},
					},
				};
			}
			const _score = _data.score2018;
			_score.score1 += Number(d.Part1);
			_score.score2 += Number(d.Part2);
			switch (d.NdcRating) {
			case '金':
				_score.ndcRating += 1;
				_score.ndc.g += 1;
				break;
			case '銀':
				_score.ndcRating += 0.6;
				_score.ndc.s += 1;
				break;
			case '銅':
				_score.ndcRating += 0.3;
				_score.ndc.b += 1;
				break;
			default:
				if (Number(d.Part1) !== 0 && Number(d.Part2) !== 0) {
					_score.ndc.n += 1;
				}
			}
			if (!found) {
				acc.push(_data);
			}
			return acc;
		}, scores);
		scores = data2019.reduce((acc, d) => {
			let found = true;
			let _data = acc.find((x) => x.name === d.City);
			if (!_data) {
				found = false;
				_data = {
					name: d.City,
					score2017: {
						score1: 0,
						score2: 0,
						ndcRating: 0,
						ndc: {
							g: 0, s: 0, b: 0, n: 0,
						},
					},
					score2018: {
						score1: 0,
						score2: 0,
						ndcRating: 0,
						ndc: {
							g: 0, s: 0, b: 0, n: 0,
						},
					},
					score2019: {
						score1: 0,
						score2: 0,
						ndcRating: 0,
						ndc: {
							g: 0, s: 0, b: 0, n: 0,
						},
					},
					score2020: {
						score1: 0,
						score2: 0,
						ndcRating: 0,
						ndc: {
							g: 0, s: 0, b: 0, n: 0,
						},
					},
				};
			}
			const _score = _data.score2019;
			_score.score1 += Number(d.Part1);
			_score.score2 += Number(d.Part2);
			switch (d.NdcRating) {
			case '金':
				_score.ndcRating += 1;
				_score.ndc.g += 1;
				break;
			case '銀':
				_score.ndcRating += 0.6;
				_score.ndc.s += 1;
				break;
			case '銅':
				_score.ndcRating += 0.3;
				_score.ndc.b += 1;
				break;
			default:
				if (Number(d.Part1) !== 0 && Number(d.Part2) !== 0) {
					_score.ndc.n += 1;
				}
			}
			if (!found) {
				acc.push(_data);
			}
			return acc;
		}, scores);
		scores = data2020.reduce((acc, d) => {
			let found = true;
			let _data = acc.find((x) => x.name === d.City);
			if (!_data) {
				found = false;
				_data = {
					name: d.City,
					score2017: {
						score1: 0,
						score2: 0,
						ndcRating: 0,
						ndc: {
							g: 0, s: 0, b: 0, n: 0,
						},
					},
					score2018: {
						score1: 0,
						score2: 0,
						ndcRating: 0,
						ndc: {
							g: 0, s: 0, b: 0, n: 0,
						},
					},
					score2019: {
						score1: 0,
						score2: 0,
						ndcRating: 0,
						ndc: {
							g: 0, s: 0, b: 0, n: 0,
						},
					},
					score2020: {
						score1: 0,
						score2: 0,
						ndcRating: 0,
						ndc: {
							g: 0, s: 0, b: 0, n: 0,
						},
					},
				};
			}
			const _score = _data.score2020;
			_score.score1 += Number(d.Part1);
			_score.score2 += Number(d.Part2);
			switch (d.NdcRating) {
			case '金':
				_score.ndcRating += 1;
				_score.ndc.g += 1;
				break;
			case '銀':
				_score.ndcRating += 0.6;
				_score.ndc.s += 1;
				break;
			case '銅':
				_score.ndcRating += 0.3;
				_score.ndc.b += 1;
				break;
			default:
				if (Number(d.Part1) !== 0 && Number(d.Part2) !== 0) {
					_score.ndc.n += 1;
				}
			}
			if (!found) {
				acc.push(_data);
			}
			return acc;
		}, scores);
		scores = scores.map((x) => ({
			...x,
			score2017: {
				...x.score2017,
				score1: x.score2017.score1 / 0.34,
				score2: x.score2017.score2 / 0.34,
				ndcRating: x.score2017.ndcRating / 0.34,
			},
			score2018: {
				...x.score2018,
				score1: x.score2018.score1 / 0.34,
				score2: x.score2018.score2 / 0.34,
				ndcRating: x.score2018.ndcRating / 0.34,
			},
			score2019: {
				...x.score2019,
				score1: x.score2019.score1 / 0.34,
				score2: x.score2019.score2 / 0.34,
				ndcRating: x.score2019.ndcRating / 0.34,
			},
			score2020: {
				...x.score2020,
				score1: x.score2020.score1 / 0.34,
				score2: x.score2020.score2 / 0.34,
				ndcRating: x.score2020.ndcRating / 0.34,
			},
		}));
		setData(scores);
	}, [data2017]);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		rows,
		prepareRow,
	} = useTable({
		columns,
		data,
		initialState: { sortBy: [{ id: 'score2020_score1', desc: true }] },
	}, useSortBy);

	return (
		<Page title="地方政府 34 共通資料集清冊">
			<Center>
				<Heading as="h2" fontSize="3xl">地方政府 34 共通資料集清冊</Heading>
			</Center>
			<Box mt={2}>
				<Center>
					<Text fontSize="md">Overview of 34 Open Datasets Commonly Used by Local Governments in Taiwan</Text>
				</Center>
			</Box>

			<Tabs>
				<TabList>
					<Tab>分數總覽</Tab>
					<Tab>評鑑指標</Tab>
					<Tab>資料清冊</Tab>
				</TabList>

				<TabPanels>
					<TabPanel>
						<Table size="lg" {...getTableProps()} variant="striped">
							<Thead>
								{headerGroups.map((headerGroup) => (
									<Tr {...headerGroup.getHeaderGroupProps()}>
										{headerGroup.headers.map((column) => (
											<Th px={0} textAlign="center" {...column.getHeaderProps(column.getSortByToggleProps({ title: '以此排序' }))}>
												{column.render('Header')}
												{column.isSorted ? (column.isSortedDesc
													? <Icon ml={2} as={Fa} icon={faCaretDown} /> : <Icon ml={2} as={Fa} icon={faCaretUp} />)
													: <Box d="inline-block" visibility="hidden"><Icon ml={2} as={Fa} icon={faCaretUp} /></Box>}
											</Th>
										))}
									</Tr>
								))}
							</Thead>
							<Tbody {...getTableBodyProps()}>
								{rows.map((row) => {
									prepareRow(row);
									return (
										<Tr {...row.getRowProps()}>
											{row.cells.map((cell) => (
												<Td p={1} isNumeric={!!cell.column.isNumeric} {...cell.getCellProps()}>
													{cell.render('Cell')}
												</Td>
											))}
										</Tr>
									);
								})}
							</Tbody>
						</Table>
					</TabPanel>
					<TabPanel>
						<Box overflowX="scroll" overflowY="scroll" w="100%" h="70vh">
							<Table variant="striped">
								<Thead>
									<Tr>
										<Th position="sticky" top="0" zIndex="99" bg="#f4f4f4">縣市</Th>
										{Object.keys(data2020[0]).filter((x) => /\d+\..*/.test(x)).map((x) => (
											<Th key={`th${x}`} position="sticky" top="0" bg="#f4f4f4" textAlign="center" minW="50px" whiteSpace="nowrap">
												{x.split('.')[1]}
											</Th>
										))}
									</Tr>
								</Thead>
								<Tbody>
									{Array.from(new Set(data2020.map((x) => x.City))).map((city) => (
										<Tr key={`trc${city}`}>
											<Td position="sticky" left="0" bg="#f4f4f4">{city}</Td>
										</Tr>
									))}
								</Tbody>
							</Table>
						</Box>
					</TabPanel>
					<TabPanel>
						<Box overflowX="scroll" overflowY="scroll" w="100%" h="70vh">
							<Table variant="striped">
								<Thead>
									<Tr>
										<Th position="sticky" top="0" zIndex="99" bg="#f4f4f4">縣市</Th>
										{Array.from(new Set(data2020.map((x) => x.OD34Name))).map((x) => (
											<Th key={`th${x}`} position="sticky" top="0" bg="#f4f4f4" textAlign="center" minW="170px" whiteSpace="nowrap">{x}</Th>
										))}
									</Tr>
								</Thead>
								<Tbody>
									{Array.from(new Set(data2020.map((x) => x.City))).map((city) => (
										<Tr key={`trc${city}`}>
											<Td position="sticky" left="0" bg="#f4f4f4">{city}</Td>
											{Array.from(new Set(data2020.map((x) => x.OD34Name))).map((x) => (
												<Td key={`tdc${x}`} fontSize="sm" textAlign="center">
													{(() => {
														const od34Data = data2020.find((d) => d.City === city && d.OD34Name === x);
														if (od34Data && od34Data.DatasetName) {
															return (
																<>
																	<Box>
																		<NextLink passHref href={`/datasets?s=${od34Data.DatasetName}`}>
																			<ChakraLink>
																				{pangu.spacing(od34Data.DatasetName)}
																			</ChakraLink>
																		</NextLink>
																	</Box>
																	{(() => {
																		const keys = Object.keys(od34Data).filter((k) => /\d+\..*/.test(k));
																		return (
																			<Tooltip
																				label={(
																					<>
																						<Text fontWeight="600">資料評鑑指標：</Text>
																						{keys.map((k) => (
																							<Text key={`d${city}${x}${k}`} fontSize="sm">
																								{k.trim()}
																								：
																								{od34Data[k] !== 0 ? '是' : <Text as="span" color="red">否</Text>}
																							</Text>
																						))}
																					</>
																				)}
																			>
																				<Box>
																					{keys.map((k) => (
																						<Box
																							key={`ind${city}${x}${k}`}
																							d="inline-block"
																							w="3px"
																							h="3px"
																							borderRadius="50%"
																							m="1px"
																							border={od34Data[k] !== 0 ? '' : '1px solid #999'}
																							backgroundColor={od34Data[k] !== 0 ? '#4AB' : '#ccc'}
																							boxShadow={od34Data[k] !== 0 ? 'inset #006 0 -1px 1px, #06F 0 0 2px' : ''}
																						/>
																					))}
																				</Box>
																			</Tooltip>
																		);
																	})()}
																</>
															);
														}
														return (
															<Tooltip label="未提供或資料格式不符本計劃訂定">
																<Text color="#777" fontSize="xs">N/A</Text>
															</Tooltip>
														);
													})()}
												</Td>
											))}
										</Tr>
									))}
								</Tbody>
							</Table>
						</Box>
					</TabPanel>
				</TabPanels>
			</Tabs>
		</Page>
	);
}
